import { MUTATION_CONTACT_DEALER, SchemaTypes } from '@allesauto/graphql';
import { ApolloError, useMutation } from '@apollo/client';

import { useAuthorizationHeader } from './useAuthorizationHeader';

export const useContactDealerMutations = (): {
  contactDealer: (
    vehicleId: string,
    dealerId: string,
    formData: SchemaTypes.ContactDealerInput,
    reCaptchaToken: string,
    configuratorId?: string
  ) => Promise<boolean>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const authorizationHeader = useAuthorizationHeader();

  const [mutationContactDealerForm, { loading, error }] = useMutation<
    Pick<SchemaTypes.Mutation, 'contactDealer'>
  >(MUTATION_CONTACT_DEALER);

  return {
    contactDealer: async (
      vehicleId,
      dealerId,
      formData,
      reCaptchaToken,
      configuratorId
    ) => {
      const { data } = await mutationContactDealerForm({
        variables: {
          vehicleId,
          dealerId,
          formData,
          configuratorId,
        },
        context: {
          headers: {
            ...authorizationHeader?.headers,
            'recaptcha-token': reCaptchaToken,
            // TODO add real value when we have it, see AAA-3458
            'recaptcha-origin': 'https://www.shop.stage.alles.auto',
          },
        },
      });
      return !!data;
    },
    loading,
    error,
  };
};
